import { useRouteMatch } from '@funtech-int/rival-react';

import { RouteMeta } from '@/shared/lib/navigation';

export function usePaymentPage() {
    const location = useRouteMatch();

    const routeMeta = location.meta as RouteMeta | undefined;

    return routeMeta?.plusPaymentPage ?? '';
}
